/* FizzyIQ — Science formula bento (scb-): scroll reveal + stat count-up. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseInt(el.textContent, 10);
    if (isNaN(target) || reduce) return;
    var start = null, dur = 1000;
    el.textContent = '0';
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * target);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initSection(root) {
    if (!root || root.dataset.scbInit === '1') return;
    root.dataset.scbInit = '1';

    function reveal() {
      root.classList.add('in-view');
      root.querySelectorAll('[data-scb-count]').forEach(countUp);
    }
    /* Anchor arrivals land mid-page without a scroll, where IO delivery is
       least reliable — reveal immediately rather than risk a blank card. */
    if ('IntersectionObserver' in window && !window.location.hash) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { reveal(); io.disconnect(); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      io.observe(root);
      window.setTimeout(function () {
        var r = root.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) reveal();
      }, 1200);
    } else {
      reveal();
    }

    /* ── mouse-reactive bits ── */

    /* 1. Nutrient matrix — lit cluster gathers under the cursor */
    var matrix = root.querySelector('.scb-matrix');
    if (matrix && !reduce) {
      var dots = Array.prototype.slice.call(matrix.querySelectorAll('.scb-dot'));
      var centers = [];
      var measure = function () {
        var mr = matrix.getBoundingClientRect();
        centers = dots.map(function (d) { var r = d.getBoundingClientRect(); return [r.left + r.width / 2 - mr.left, r.top + r.height / 2 - mr.top]; });
      };
      measure();
      window.addEventListener('resize', measure);
      var mRaf = null, mx = 0, my = 0;
      matrix.addEventListener('mousemove', function (e) {
        var mr = matrix.getBoundingClientRect();
        mx = e.clientX - mr.left; my = e.clientY - mr.top;
        if (mRaf) return;
        mRaf = requestAnimationFrame(function () {
          mRaf = null;
          matrix.classList.add('matrix-hover');
          var R = 46 * 46;
          for (var i = 0; i < dots.length; i++) {
            var dx = centers[i][0] - mx, dy = centers[i][1] - my;
            dots[i].classList.toggle('is-near', (dx * dx + dy * dy) < R);
          }
        });
      });
      matrix.addEventListener('mouseleave', function () {
        matrix.classList.remove('matrix-hover');
        dots.forEach(function (d) { d.classList.remove('is-near'); });
      });
    }

  }

  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('.scb'), initSection); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) { var r = e.target.querySelector('.scb'); if (r) initSection(r); }
  });
})();
